
const config = {
    "baseUrl": process.env.REACT_APP_API_URL
}

export default config;
